import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchError } from "../actions/Common";
import { fetchLetterDetailSuccess, fetchDraftDetailSuccess, fetchLetterRefersSuccess, fetchUrgentTypeSuccess, fetchClassificationTypeSuccess, onSaveSuccess, fetchLetterLocationSuccess, fetchLetterLetterNoteSuccess, onGetLetterTemplateSuccess } from "../actions";
import { goBack } from "connected-react-router";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import { ILetterReferParams } from "../../interfaces";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getLetterDetail = async (letterCode: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letter/getLetterDetail?letterCode=${letterCode}`);
}

const getdraftDetail = async (letterCode: string, taskId?: string | undefined) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`draft/getdraftDetail`, {
        params: {
            letterCode: letterCode,
            taskId: taskId ? taskId : "",
        }
    });
}

// old version
const getLetterRefersOld = async (params: ILetterReferParams) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`refer/getLetterRefers`, {
        params: { letterCode: params.letterCode, onlyMe: params.onlyMe }
    });
}

// new version
const getLetterRefers = async (params: ILetterReferParams) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`refer/getRefers`, {
        params: { letterCode: params.letterCode, onlyMe: params.onlyMe }
    });
}

const getUrgentType = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letter/GetUrgentTypes`);
}

const getClassificationType = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letter/getConfidentialTypes`);
}

const SaveLetter = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("draft/saveletter", parameters);
}

const getLetterLocation = async (letterCode: string) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`refer/GetLetterLocation?letterCode=${letterCode}`);
}

function* onSaveRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(SaveLetter, action.payload);
        ShowSuccess(messages["messages.operationWasSuccessful"], "");
    } catch (error) {
        return ShowError("", error);
    }
}

export function* SaveRequest() {
    yield takeEvery(ActionTypes.SAVE_LETTER, onSaveRequest);
}

function* fetchLetterDetailRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterDetail = yield call(getLetterDetail, action.payload);
        yield put(fetchLetterDetailSuccess(fetchedLetterDetail.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterDetail() {
    yield takeEvery(ActionTypes.GET_LETTER_DETAIL, fetchLetterDetailRequest);
}

function* fetchDraftDetailRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedDraftDetail = yield call(getdraftDetail, action.payload.letterCode, action.payload.taskId);
        yield put(fetchDraftDetailSuccess(fetchedDraftDetail.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchDraftDetail() {
    yield takeEvery(ActionTypes.GET_DRAFT_DETAIL, fetchDraftDetailRequest);
}

// LetterRefers
function* fetchLetterRefersRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        if (!action.payload.letterCode) {
            return;
        }
        const fetchedLetterRefers = yield call(getLetterRefers, action.payload);
        yield put(fetchLetterRefersSuccess(fetchedLetterRefers.data));
    } catch (error) {
        // console.log('GET_LETTER_REFERS Errors = >',error)
        return ShowError("", error);
    }
}

export function* fetchLetterRefers() {
    yield takeEvery(ActionTypes.GET_LETTER_REFERS, fetchLetterRefersRequest);
}

// UrgentType
function* fetchUrgentTypeRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedUrgentType = yield call(getUrgentType);
        yield put(fetchUrgentTypeSuccess(fetchedUrgentType.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchUrgentType() {
    yield takeEvery(ActionTypes.GET_URGENT_TYPE, fetchUrgentTypeRequest);
}

// ClassificationType
function* fetchClassificationTypeRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedClassificationType = yield call(getClassificationType);
        yield put(fetchClassificationTypeSuccess(fetchedClassificationType.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchClassificationType() {
    yield takeEvery(ActionTypes.GET_CLASSIFICATION_TYPE, fetchClassificationTypeRequest);
}

function* fetchLetterLocationRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterLocation = yield call(getLetterLocation, action.payload);
        yield put(fetchLetterLocationSuccess(fetchedLetterLocation.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterLocation() {
    yield takeEvery(ActionTypes.GET_LETTER_LOCATION, fetchLetterLocationRequest);
}

const getLetterTemplateRequet = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`letter/GetLetterTemplate`);
}

function* fetchLetterTemplateRequest(): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterTemplate = yield call(getLetterTemplateRequet);
        yield put(onGetLetterTemplateSuccess(fetchedLetterTemplate.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterTempalate() {
    yield takeEvery(ActionTypes.GET_LETTER_TEMPLATE, fetchLetterTemplateRequest);
}

export default function* rootSaga() {
    yield all([
        fork(fetchLetterDetail),
        fork(fetchDraftDetail),
        fork(fetchLetterRefers),
        fork(fetchUrgentType),
        fork(fetchClassificationType),
        fork(SaveRequest),
        fork(fetchLetterLocation),
        fork(fetchLetterTempalate)
    ]);
}

